import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import {
	ButtonsContainer,
	CloseButton,
	ComponentContainer,
	Container,
	Content,
	ModalMainSection,
	ModalTitle,
	TitleContainer
} from './styled'
import { Close } from '../../../assets/icons'

const Modal = ({
	children,
	isFullHeight = false,
	onClose,
	widthDesktop = '500px',
	withComponentContainer = false,
	componentContainerProps = {},
	title,
	titleAlign = 'left',
	buttons,
	buttonsContainerProps = {},
	withMainSection = false,
	mainSectionProps = {}
}) => {
	useEffect(() => {
		disableBodyScroll(document.body)
		return () => clearAllBodyScrollLocks()
	}, [])

	const renderTitle = () => {
		if (!title) return null
		return (
			<TitleContainer $titleAlign={titleAlign}>
				{React.isValidElement(title) ? title : <ModalTitle $titleAlign={titleAlign}>{title}</ModalTitle>}
			</TitleContainer>
		)
	}

	const content = (
		<>
			{withMainSection ? (
				<ModalMainSection {...mainSectionProps}>
					{renderTitle()}
					{children}
				</ModalMainSection>
			) : (
				<>
					{renderTitle()}
					{children}
				</>
			)}
			{buttons && <ButtonsContainer {...buttonsContainerProps}>{buttons}</ButtonsContainer>}
		</>
	)

	return ReactDOM.createPortal(
		<Container isFullHeight={isFullHeight} widthDesktop={widthDesktop}>
			<Content isFullHeight={isFullHeight} widthDesktop={widthDesktop}>
				{onClose && (
					<CloseButton onClick={onClose}>
						<Close size={20} />
					</CloseButton>
				)}
				{withComponentContainer ? (
					<ComponentContainer isFullHeight={isFullHeight} {...componentContainerProps}>
						{content}
					</ComponentContainer>
				) : (
					content
				)}
			</Content>
		</Container>,
		document.body
	)
}

export default Modal
